export const SearchCategoriesToExclude = new Set([
  '642d8c01c30a37e4572591e7', // test-fj8900n
]);
